package devxertech.com.pages.services.chatbotDevelopment

import androidx.compose.runtime.Composable
import devxertech.com.seo.PageMetadata
import devxertech.com.seo.PageSeo
import devxertech.com.seo.ChatbotServiceJsonLd
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.commons.ServiceArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.services.aiDevelopmentService.aiDevelopmentTool.AiDevelopmentTool
import devxertech.com.pages.services.chatbotDevelopment.chatbotStrategy.ChatBotStrategy
import devxertech.com.pages.services.chatbotDevelopment.chatbot_Services.ChatBotServicesSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import devxertech.com.utils.Res.Image.chatbot_About
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.percent

@Page("/chatbot-development")
@Composable
fun AiDevelopmentServices() {
    PageMetadata(PageSeo.Chatbot)
    ChatbotServiceJsonLd()
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
//
        CommonHeader(
            mainHeadingAsH1 = true,
            image = Res.Image.chatbot_Header,
            imageAlt = "Custom AI chatbot interface",
            breakpoint = breakpoint,
            headingText = "Custom AI Chatbot & Assistant Development", chatbotChanges = true,
            descriptionText = "Help your customers find answers and your team handle inquiries more effectively. We build custom AI chatbots and assistants around your business information, website and workflows.\n\nWhether you need website support or lead qualification, we start with a clear use case and scope the solution around your requirements.",
            chatbotHeightModification = true, careerFontSize = true,
            startProjectText = "Discuss Your Chatbot Project",
            startProjectButtonWidth = 250
        )
//
        ServiceArrow("AI Chatbot Development")
//
        CommonAboutSection(
            breakpoint = breakpoint,
            title = "See How?",
            firstFont = "AI Models Leveraged by",
            secondFont = "Our Specialists",
            description = "Devxer Technology is dedicated to revolutionizing customer" +
                    "interactions with chat bot development services.Whether " +
                    "in e-commerce or customer service, our chat bots automate tasks, " +
                    "offer real-time support, and create personalized experiences." +
                    " Maintain a competitive edge in the digital landscape with our" +
                    " adaptable, smart, and ready-to-deploy conversational chat bot solutions." +
                    " Trust us as your AI Chat bot Development Company to enhance customer" +
                    " engagement and optimize operational efficiency.",
            imageName = chatbot_About
        )
// Original chatbot service cards remain alongside the new business-focused use cases.
        ChatBotServicesSection(breakpoint, sitePalette)
        BusinessAssistantServices(breakpoint, sitePalette)
//
// Original platform graphic and responsive layout retained in place.
        Column(
            modifier = Modifier.fillMaxWidth().margin(top = if (breakpoint > Breakpoint.MD) 20.px else 0.px)
                .padding(top = 30.px, bottom = 50.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "How diversely",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = 18.px,
                textAlign = TextAlign.Center,
                textTransform = TextTransform.Uppercase
            )
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FieldTitleTextNormalSimple(
                    "DEVXER ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint == Breakpoint.LG) 30.px else if (breakpoint < Breakpoint.LG) 22.px else 35.px,
                    fontWeight = 700,
                )
                FieldTitleTextNormalSimple(
                    " INTEGRATE INTO",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint == Breakpoint.LG) 30.px else if (breakpoint < Breakpoint.LG) 22.px else 35.px,
                    fontWeight = 700,
                )
                FieldTitleTextNormalSimple(
                    " Different Platforms",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint == Breakpoint.LG) 30.px else if (breakpoint < Breakpoint.LG) 22.px else 35.px,
                    fontWeight = 700,
                )
                Box(modifier = Modifier.fillMaxWidth().margin(top = 30.px), contentAlignment = Alignment.Center) {
                    Image(src = Res.Image.chatbot_Platform, modifier = Modifier
                        .attrsModifier { attr("alt", "Platforms supported by chatbot development") }
                        .fillMaxWidth(if(window.screen.width > 475) 63.percent else 90.percent)
                        .margin(top = 20.px, bottom = 20.px,
                            left = if (breakpoint <= Breakpoint.MD) 33.px else if (breakpoint == Breakpoint.LG) 53.px else 90.px)
                    )
                }
            }
        }
        AiAssistantDemo(breakpoint, sitePalette)
//
        ChatBotStrategy(breakpoint, sitePalette)
        DevxerProsShowcase(breakpoint, sitePalette)
        AssistantFaq(breakpoint, sitePalette)
//
        MakeYourOwnTeam(breakpoint)
//
        AiDevelopmentTool(breakpoint, sitePalette, text = "AI Chat DEVELOPMENT")
//
        RatingSection(breakpoint)
//
        HomepageFooter(breakpoint)

    }
}
